import { defineComponent as N, ref as v, computed as T, watch as w, createElementBlock as u, openBlock as n, withKeys as y, createVNode as _, createBlock as k, createElementVNode as o, unref as c, withCtx as g, Fragment as B, renderList as E, createTextVNode as S, toDisplayString as b } from "vue";
import { useLoadingState as j, ScalarSearchInput as q, ScalarLoading as A, ScalarSearchResultList as D } from "@scalar/components";
import { useDebounceFn as F } from "@vueuse/core";
import { Client as H } from "typesense";
import { useRouter as P } from "vue-router";
import Q from "./TypesenseSearchResult.vue.js";
const z = {
  key: 0,
  class: "guides-search-empty-state"
}, O = {
  key: 1,
  class: "guides-search-empty-state"
}, U = {
  key: 2,
  class: "guides-search-loading"
}, ee = /* @__PURE__ */ N({
  __name: "TypesenseSearch",
  props: {
    typesenseKey: {},
    typesenseHost: {},
    typesenseCollection: {}
  },
  emits: ["close"],
  setup(L, { emit: C }) {
    const r = L, K = C, { resolve: V, push: $ } = P(), x = {
      query_by: "page_content",
      highlight_affix_num_tokens: 6,
      per_page: 24
    }, p = j(), R = new H({
      apiKey: r.typesenseKey,
      // Be sure to use the search-only-api-key fo typesense
      nodes: [
        {
          host: r.typesenseHost,
          port: 443,
          protocol: "https"
        }
      ],
      connectionTimeoutSeconds: 2
    }), a = v([]), l = v(""), d = v(0), m = T(
      () => a.value[d.value]
    ), I = F(async (s) => {
      const e = await R.collections(r.typesenseCollection).documents().search({ q: s, ...x });
      p.stopLoading(), a.value = (e.hits || []).map((t) => {
        var i;
        return {
          ...t.document,
          uid: `search-result-${t.document.page_uid}`,
          snippet: (i = t.highlight.page_content) == null ? void 0 : i.snippet,
          route: V({
            name: t.document.page_uid,
            params: {
              project: t.document.project_uid,
              version: t.document.version_uid,
              guide: t.document.guide_uid
            }
          })
        };
      });
    }, 325);
    w(l, async (s) => {
      s && r.typesenseKey ? (p.startLoading(), I(s)) : a.value = [];
    }), w(m, (s) => {
      var e;
      !document || !s || (e = document.getElementById(s.uid)) == null || e.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
    });
    function h(s) {
      const e = d.value, t = a.value.length;
      d.value = (e + t + s) % t;
    }
    function f(s) {
      m.value && ($(s ?? m.value.route), K("close"));
    }
    return (s, e) => (n(), u("div", {
      class: "guides-search",
      onKeydown: [
        e[1] || (e[1] = y((t) => h(1), ["down"])),
        e[2] || (e[2] = y((t) => f(), ["enter"])),
        e[3] || (e[3] = y((t) => h(-1), ["up"]))
      ]
    }, [
      _(c(q), {
        modelValue: l.value,
        "onUpdate:modelValue": e[0] || (e[0] = (t) => l.value = t)
      }, null, 8, ["modelValue"]),
      s.typesenseKey ? l.value.length ? c(p).isLoading ? (n(), u("div", U, [
        _(c(A), {
          isLoading: "",
          size: "md"
        })
      ])) : (n(), k(c(D), {
        key: 3,
        class: "guides-search-results custom-scroll",
        noResults: !a.value.length
      }, {
        query: g(() => [
          S(b(l.value), 1)
        ]),
        default: g(() => [
          (n(!0), u(B, null, E(a.value, (t, i) => (n(), k(Q, {
            id: t.uid,
            key: `${i}${t.page_uid}`,
            active: d.value === i,
            snippet: t.snippet,
            onClick: (G) => f(t.route)
          }, {
            default: g(() => [
              S(b(t.page_title), 1)
            ]),
            _: 2
          }, 1032, ["id", "active", "snippet", "onClick"]))), 128))
        ]),
        _: 1
      }, 8, ["noResults"])) : (n(), u("div", O, e[5] || (e[5] = [
        o("div", null, "Type Query Above", -1)
      ]))) : (n(), u("div", z, e[4] || (e[4] = [
        o("div", null, " On your published sites your content will be fully searchable allowing users to move around your documents with ease ✨ ", -1)
      ]))),
      e[6] || (e[6] = o("div", { class: "guides-search-meta" }, [
        o("span", {
          "aria-hidden": "true",
          class: "contents"
        }, [
          o("span", null, "↑↓ Navigate"),
          o("span", null, "⏎ Select")
        ]),
        o("span", { class: "sr-only" }, " Press up arrow / down arrow to navigate, enter to select, type to filter results ")
      ], -1))
    ], 32));
  }
});
export {
  ee as default
};
